import { createSlice } from "@reduxjs/toolkit"

export const Currency = createSlice({
    name: "currency",
    initialState: {
        currencySymbol: ""
    },
    reducers: {
        CurrencyAction: (state, action) => {
            state.currencySymbol = action.payload
        },
    }
})

export const { CurrencyAction } = Currency.actions;

export default Currency.reducer;